import React, { FC } from 'react';
import { View, TouchableOpacity, Text, StyleSheet, Platform } from 'react-native';
import InputLine from '@components/machines/components/detailsComponents/activeMachine/components/InputLine';
import { Element, scale } from '@components/frame';
import { isWeb } from '@helpers';
import i18n from 'i18n-js';

interface TranslationProps {
  C?: (color: string) => string;
  translationFilePath?: string;
}

const Translation: FC<TranslationProps> = ({ C = (color) => color, translationFilePath = 'translation.csv' }) => {
  const handleDownload = () => {
    if (isWeb) {
      const link = document.createElement('a');
      link.href = translationFilePath;
      link.download = 'translation.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert('Direct file download is not supported in the mobile app');
    }
  };

  return (
    <View style={{ width: '100%', marginTop: scale(144) }}>
      <Element
        {...{
          config: {
            position: {
              top: 0,
              right: 180,
              left: 180,
            },
          },
          configMobile: {
            position: {
              top: 0,
              right: 0,
              left: 0,
            },
          },
        }}
      >
        <InputLine
          borderBottomRadius
          borderTopRadius
          data={[{}]}
          onlyLabel={false}
          index={0}
          i={{
            Component: () => (
              <TouchableOpacity onPress={handleDownload} style={styles.downloadButton}>
                <Text style={styles.downloadText}>{i18n.t('Download CSV')}</Text>
              </TouchableOpacity>
            ),
          }}
          C={C}
          loading={false}
        />
      </Element>
    </View>
  );
};

const styles = StyleSheet.create({
  downloadButton: {
    paddingHorizontal: 12,
  },
  downloadText: {
    color: '#0066cc',
  },
});

export default Translation;
